import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Service from "../../API/Service";
import MyButton from "../../components/UI/MyButtons/MyButton";
import cl from "../../styles/StudIdPage.module.css"
import avatar from "../../Assets/Avatar.svg"
import block from "../../Assets/icons/lock_red.svg";

const AdminIdPage = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [updatedData, setUpdatedData] = useState({
        name: "",
        surname: "",
        birthDate: "",
        login: "",
        phone: "",
        isBlocked: false
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getById(id, "admins");
                const data = response?.data || {};

                setUpdatedData({
                    name: data.name || "",
                    surname: data.surname || "",
                    birthDate: data.birthDate || "",
                    login: data.login || "",
                    phone: data.phone || "",
                    isBlocked: data.isBlocked || false
                });

            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        //TODO потом нужно сделать так чтобы эта страница наследовала стили от студента
        //TODO или надо сделать новый файл стилей для IdPage
        //TODO думаю что-то похожее надо сделать для EditPage и тд
        //TODO но это будет делаться в конце, так что не спешим менять
        <div className={cl.mainBlock}>
            <p>Admin</p>
            <div className={cl.content}>
                <div className={cl.avatarAndName}>
                    <img
                        src={avatar}
                        alt={"avatar"}
                        className={cl.avatar}
                    />
                    <div className={cl.wrap}>
                        <b>{updatedData.name} {updatedData.surname}</b>
                        {updatedData.isBlocked === true && (
                            <div className={cl.blockInfo}>
                                Blocked
                                <img src={block} alt={"block"}/>
                            </div>
                        )}
                    </div>

                </div>
                <dl className={cl.info}>
                    <div className={cl.userInfoRow}>
                        <dt>Date of birth</dt>
                        <dd>{updatedData.birthDate}</dd>
                    </div>
                    <div className={cl.userInfoRow}>
                        <dt>Email</dt>
                        <dd>{updatedData.login}</dd>
                    </div>
                    <div className={cl.userInfoRow}>
                        <dt>Phone number</dt>
                        <dd>{updatedData.phone}</dd>
                    </div>
                </dl>
            </div>
            <div className={"buttons"}>
                <MyButton
                    content={"Back"}
                    isBlue={false}
                    onClick={() => navigate(-1)}
                />
            </div>
        </div>
    );
};

export default AdminIdPage;